export default __webpack_public_path__ + "static/media/legend_prequaternary_elevation.9dbc3ba8.png";